document.addEventListener('DOMContentLoaded', async function () {
    const container = document.getElementById('related_content');
    if (!container) return;

    const path = container.dataset.relatedContentPath;
    const locale = container.dataset.relatedContentLocale;
    if (!path) return;

    const requestUrl = new URL(path, window.location.origin);
    requestUrl.searchParams.set('locale', locale);

    // Request HTML content via AJAX - using Accept: text/html since we're fetching a partial,
    // and X-Requested-With to identify this as an AJAX request for controller validation
    try {
        const response = await fetch(requestUrl, {
            method: 'GET',
            headers: {
                Accept: 'text/html',
                'X-Requested-With': 'XMLHttpRequest'
            },
            credentials: 'same-origin'
        });
        container.outerHTML = await response.text();
    } catch {
        // Silently fail
    }
});
